var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('s-main',{staticClass:"s-center"},[_c('s-aside',[_c('div',{attrs:{"id":"left-section"}},[_c('business-card',{attrs:{"id":"user-profile-detail"}})],1)]),_c('s-content',{staticClass:"s-sticky-aside s-content s-aside-1 float-left"},[_c('order-list',{attrs:{"id":"order-list"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }